/* eslint-disable */ import { $DomainEntityReflection, EnhancedAliasReflection } from '@salsita-ai/platform-project-sdk/domain';
import { BaseCabinet, BaseCabinet1Drawer2Doors, BaseCabinet2Door, BaseCabinet3Drawer, BaseCabinet4Drawer, Cabinet, Countertop, EmptySpace, NoCabinet, Scene, TallCabinet, TallCabinet24, TallCabinet36, WallCabinet } from './model/index.js';
export const constants = {
    Scene: {
        $productCode: 'SCENE',
        $name: 'Scene',
        $description: 'overall scene container',
        $hardwareMaterialSwatches: {
            black: {
                swatchName: 'Black',
                color: '#000000'
            },
            satinNickel: {
                swatchName: 'Satin Nickel',
                color: '#C0C0C0'
            }
        }
    },
    NoCabinet: {
        $fabOffsetY: 35,
        $height: 40
    },
    Cabinet: {
        $defaultMaterialName: 'cabinetBodyMaterial'
    },
    Countertop: {
        $defaultMaterialName: 'countertopMaterial',
        $productCode: 'COUNTERTOP',
        $name: 'Countertop',
        $description: 'Countertop to cover base cabinets'
    },
    EmptySpace: {
        $productCode: 'EMPTYSPACE',
        $name: 'Empty space',
        $description: 'Empty space with no cabinet'
    },
    BaseCabinet2Door: {
        $productCode: 'BFH24',
        $name: '2 Door Base Cabinet',
        $description: 'Base cabinet with 2 doors'
    },
    BaseCabinet1Drawer2Doors: {
        $productCode: 'B24',
        $name: '1 Drawer Base Cabinet',
        $description: 'Base cabinet with 1 drawer and 2 doors'
    },
    BaseCabinet3Drawer: {
        $productCode: 'B3D24',
        $name: '3 Drawer Base Cabinet',
        $description: 'Base cabinet with 3 drawers'
    },
    BaseCabinet4Drawer: {
        $productCode: 'B4D24',
        $name: '4 Drawer Base Cabinet',
        $description: 'Base cabinet with 4 drawers'
    },
    TallCabinet24: {
        $productCode: 'T2484',
        $name: 'Standard Tall Cabinet',
        $description: '24" wide tall cabinet'
    },
    TallCabinet36: {
        $productCode: 'T3684',
        $name: '36" Wide Tall Cabinet',
        $description: '36" wide tall cabinet'
    },
    WallCabinet: {
        $productCode: 'W2430',
        $name: 'Wall Cabinet',
        $description: 'Standard wall-mounted cabinet',
        $fabOffsetY: 70,
        $height: 80
    },
    BaseCabinet: {
        $fabOffsetY: 20,
        $height: 40
    },
    Segment24: {
        $width: 24
    },
    Segment36: {
        $width: 36
    },
    TallCabinet: {
        $fabOffsetY: 40,
        $height: 80
    }
};
const SceneExpressions = [
    '$segmentTotals',
    '$bom',
    '$productGroups',
    '$price',
    '$isEmptyScene',
    '$screenSizeAwareMaxDistance',
    '$boundingBoxMinX',
    '$boundingBoxMaxX',
    '$boundingBoxMaxY',
    '$initialBaseCabinetRecipes',
    '$initialTallCabinetRecipes',
    '$initialWallCabinetRecipes',
    '$colorSwatches',
    '$countertopColorSwatches',
    '$hardwareMaterialSwatches',
    '$floorTextureSwatches',
    '$segments',
    '$productCode',
    '$name',
    '$description',
    '$violations'
];
const SegmentExpressions = [
    '$colorName',
    '$fabCenteredOffsetX',
    '$fabOffsetY',
    '$baseCabinetRecipes',
    '$tallCabinetRecipes',
    '$wallCabinetRecipes',
    '$wallCabinetAboveRecipes',
    '$baseCabinetLeftRecipes',
    '$tallCabinetLeftRecipes',
    '$wallCabinetLeftRecipes',
    '$noCabinetRecipes',
    '$noCabinetLeftRecipes',
    '$emptySpaceRecipes',
    '$emptySpaceLeftRecipes',
    '$scene'
];
const BaseCabinetExpressions = [
    '$matchingCountertop',
    '$noWallCabinetAbove',
    '$fabOffsetY',
    '$height'
];
const NoCabinetExpressions = [
    '$noWallCabinetAbove',
    '$fabOffsetY',
    '$height'
];
const CabinetExpressions = [
    '$material',
    '$color',
    '$hardwareMaterialColor',
    '$defaultMaterialName'
];
const CountertopExpressions = [
    '$isIncluded',
    '$material',
    '$color',
    '$isExcluded',
    '$width',
    '$isStandaloneCountertop',
    '$baseCabinetWithoutCountertopRecipes',
    '$defaultMaterialName',
    '$productCode',
    '$name',
    '$description'
];
const EmptySpaceExpressions = [
    '$fabCenteredOffsetX',
    '$fabOffsetY',
    '$productCode',
    '$name',
    '$description'
];
const NonWallCabinetSegmentExpressions = [
    '$isLastSegment',
    '$fabRightOffsetX',
    '$fabOffsetY',
    '$isFirstSegment',
    '$replacementRecipes'
];
const WallCabinetExpressions = [
    '$isLastSegment',
    '$fabOffsetY',
    '$isFirstSegment',
    '$noBaseCabinetBelow',
    '$baseCabinetBelowRecipes',
    '$noCabinetBelowRecipes',
    '$productCode',
    '$name',
    '$description',
    '$height'
];
const BaseCabinet2DoorExpressions = [
    '$productCode',
    '$name',
    '$description'
];
const BaseCabinet1Drawer2DoorsExpressions = [
    '$productCode',
    '$name',
    '$description'
];
const BaseCabinet3DrawerExpressions = [
    '$productCode',
    '$name',
    '$description'
];
const BaseCabinet4DrawerExpressions = [
    '$productCode',
    '$name',
    '$description'
];
const TallCabinet24Expressions = [
    '$productCode',
    '$name',
    '$description'
];
const TallCabinet36Expressions = [
    '$productCode',
    '$name',
    '$description'
];
const Segment24Expressions = [
    '$width'
];
const Segment36Expressions = [
    '$width'
];
const TallCabinetExpressions = [
    '$fabOffsetY',
    '$height'
];
export const $Scene = new $DomainEntityReflection('Scene', [
    ...SceneExpressions
]);
export const $BaseCabinet2Door = new $DomainEntityReflection('BaseCabinet2Door', [
    ...BaseCabinet2DoorExpressions,
    ...BaseCabinetExpressions,
    ...CabinetExpressions,
    ...NonWallCabinetSegmentExpressions,
    ...SegmentExpressions,
    ...Segment24Expressions
]);
export const $BaseCabinet1Drawer2Doors = new $DomainEntityReflection('BaseCabinet1Drawer2Doors', [
    ...BaseCabinet1Drawer2DoorsExpressions,
    ...BaseCabinetExpressions,
    ...CabinetExpressions,
    ...NonWallCabinetSegmentExpressions,
    ...SegmentExpressions,
    ...Segment24Expressions
]);
export const $BaseCabinet3Drawer = new $DomainEntityReflection('BaseCabinet3Drawer', [
    ...BaseCabinet3DrawerExpressions,
    ...BaseCabinetExpressions,
    ...CabinetExpressions,
    ...NonWallCabinetSegmentExpressions,
    ...SegmentExpressions,
    ...Segment24Expressions
]);
export const $BaseCabinet4Drawer = new $DomainEntityReflection('BaseCabinet4Drawer', [
    ...BaseCabinet4DrawerExpressions,
    ...BaseCabinetExpressions,
    ...CabinetExpressions,
    ...NonWallCabinetSegmentExpressions,
    ...SegmentExpressions,
    ...Segment24Expressions
]);
export const $TallCabinet24 = new $DomainEntityReflection('TallCabinet24', [
    ...TallCabinet24Expressions,
    ...TallCabinetExpressions,
    ...CabinetExpressions,
    ...NonWallCabinetSegmentExpressions,
    ...SegmentExpressions,
    ...Segment24Expressions
]);
export const $TallCabinet36 = new $DomainEntityReflection('TallCabinet36', [
    ...TallCabinet36Expressions,
    ...TallCabinetExpressions,
    ...CabinetExpressions,
    ...NonWallCabinetSegmentExpressions,
    ...SegmentExpressions,
    ...Segment36Expressions
]);
export const $WallCabinet = new $DomainEntityReflection('WallCabinet', [
    ...WallCabinetExpressions,
    ...CabinetExpressions,
    ...SegmentExpressions,
    ...Segment24Expressions
]);
export const $Countertop = new $DomainEntityReflection('Countertop', [
    ...CountertopExpressions,
    ...NoCabinetExpressions,
    ...NonWallCabinetSegmentExpressions,
    ...SegmentExpressions,
    ...Segment24Expressions
]);
export const $EmptySpace = new $DomainEntityReflection('EmptySpace', [
    ...EmptySpaceExpressions,
    ...NoCabinetExpressions,
    ...NonWallCabinetSegmentExpressions,
    ...SegmentExpressions,
    ...Segment24Expressions
]);
export const $AnyDomainEntity = new EnhancedAliasReflection('$AnyDomainEntity', [
    Scene.type,
    BaseCabinet2Door.type,
    BaseCabinet1Drawer2Doors.type,
    BaseCabinet3Drawer.type,
    BaseCabinet4Drawer.type,
    TallCabinet24.type,
    TallCabinet36.type,
    WallCabinet.type,
    Countertop.type,
    EmptySpace.type
]);
export const $RootEntity = new EnhancedAliasReflection('$RootEntity', [
    Scene.type
]);
export const $BaseCabinet = new EnhancedAliasReflection('$BaseCabinet', [
    BaseCabinet2Door.type,
    BaseCabinet1Drawer2Doors.type,
    BaseCabinet3Drawer.type,
    BaseCabinet4Drawer.type
]);
export const $TallCabinet = new EnhancedAliasReflection('$TallCabinet', [
    TallCabinet24.type,
    TallCabinet36.type
]);
export const $Cabinet = new EnhancedAliasReflection('$Cabinet', [
    ...BaseCabinet.types,
    ...TallCabinet.types,
    WallCabinet.type
]);
export const $NoCabinet = new EnhancedAliasReflection('$NoCabinet', [
    Countertop.type,
    EmptySpace.type
]);
export const $NonWallCabinetSegment = new EnhancedAliasReflection('$NonWallCabinetSegment', [
    ...BaseCabinet.types,
    ...TallCabinet.types,
    ...NoCabinet.types
]);
export const $Segment = new EnhancedAliasReflection('$Segment', [
    ...Cabinet.types,
    ...NoCabinet.types
]);
export const $SegmentWithPrice = new EnhancedAliasReflection('$SegmentWithPrice', [
    Countertop.type,
    ...Cabinet.types
]);
export const $Segment24 = new EnhancedAliasReflection('$Segment24', [
    ...BaseCabinet.types,
    TallCabinet24.type,
    WallCabinet.type,
    ...NoCabinet.types
]);
export const $Segment36 = new EnhancedAliasReflection('$Segment36', [
    TallCabinet36.type
]);
export const $entityReflections = {
    Scene: $Scene,
    BaseCabinet2Door: $BaseCabinet2Door,
    BaseCabinet1Drawer2Doors: $BaseCabinet1Drawer2Doors,
    BaseCabinet3Drawer: $BaseCabinet3Drawer,
    BaseCabinet4Drawer: $BaseCabinet4Drawer,
    TallCabinet24: $TallCabinet24,
    TallCabinet36: $TallCabinet36,
    WallCabinet: $WallCabinet,
    Countertop: $Countertop,
    EmptySpace: $EmptySpace
};

//# sourceMappingURL=enhanced-model.js.map